/** Shared share-sheet copy (EN / SK / CS): themes, actions and export results. */
export const shareImageCopy = {
  en: {
    save: 'Save image',
    share: 'Share',
    saved: 'Image saved.',
    unavailable: 'Sharing is unavailable on this device. You can save the image instead.',
    failed: 'The image could not be exported. Please try again.',
    theme: { ink: 'Ink', gold: 'Gold', paper: 'Paper', teal: 'Teal' },
    reading: { title: 'Share progress', preview: 'Image preview: currently reading {{title}}' },
    finished: { title: 'Share finished book', preview: 'Image preview: finished {{title}}' },
    month: { title: 'Share your month', preview: 'Image preview: {{title}}' },
    achievements: { title: 'Share achievements', preview: 'Image preview: {{title}}' },
  },
  sk: {
    save: 'Uložiť obrázok',
    share: 'Zdieľať',
    saved: 'Obrázok uložený.',
    unavailable: 'Zdieľanie na tomto zariadení nie je dostupné. Obrázok si môžeš uložiť.',
    failed: 'Obrázok sa nepodarilo exportovať. Skús to znova.',
    theme: { ink: 'Atrament', gold: 'Zlatá', paper: 'Papier', teal: 'Tyrkysová' },
    reading: { title: 'Zdieľať progres', preview: 'Náhľad obrázka: práve čítam {{title}}' },
    finished: { title: 'Zdieľať dočítanú knihu', preview: 'Náhľad obrázka: dočítané {{title}}' },
    month: { title: 'Zdieľať mesiac', preview: 'Náhľad obrázka: {{title}}' },
    achievements: { title: 'Zdieľať výzvy', preview: 'Náhľad obrázka: {{title}}' },
  },
  cs: {
    save: 'Uložit obrázek',
    share: 'Sdílet',
    saved: 'Obrázek uložen.',
    unavailable: 'Sdílení na tomto zařízení není dostupné. Obrázek si můžeš uložit.',
    failed: 'Obrázek se nepodařilo exportovat. Zkus to znovu.',
    theme: { ink: 'Inkoust', gold: 'Zlatá', paper: 'Papír', teal: 'Tyrkysová' },
    reading: { title: 'Sdílet pokrok', preview: 'Náhled obrázku: právě čtu {{title}}' },
    finished: { title: 'Sdílet dočtenou knihu', preview: 'Náhled obrázku: dočteno {{title}}' },
    month: { title: 'Sdílet měsíc', preview: 'Náhled obrázku: {{title}}' },
    achievements: { title: 'Sdílet výzvy', preview: 'Náhled obrázku: {{title}}' },
  },
} as const;
